export const minName = 3;
export const maxName = 100;
export const minEmail = 3;
export const maxEmail = 100;
export const minSubject = 10;
export const maxSubject = 100;
export const minDescription = 20;
export const maxDescription = 1000;
export const minMobile = 8;
export const maxMobile = 20;
export const minPassword = 8;
export const maxPassword = 20;

export const Regex = {
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=.*[0-9]).*$/,
  mobile: /^[0-9]+$/,
  twoDecimal: /^\d*(\.\d{0,2})?$/,
  numeric: /^[1-9\b]+$/,
};
